import { getDefaultFleetParamBase, IFleetParamBase } from './IFleetParamBase'

export interface IFleetParamCoverage extends IFleetParamBase {
  cov_id: number | null //identifiant de la simulation servant de template
}

export function getDefaultFleetParamCoverage({
  missionIds = [],
  freeMissionIds = [],
  associationIds = [],
  missionHisto = [],
  start_date = null,
  end_date = null,
  cov_id = null,
  manager = '',
  phone = '',
  argos = {},
} = {}): IFleetParamCoverage {
  return {
    ...getDefaultFleetParamBase({
      missionIds,
      freeMissionIds,
      associationIds,
      missionHisto,
      start_date,
      end_date,
      manager,
      phone,
      argos,
    }),
    cov_id,
  }
}

//retourne une liste de code d'erreur si la configuration n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForFleetCoverage(data: IFleetParamCoverage | null): Array<string> {
  const errorCode = [] as Array<string>
  //if((data?.mission_start_date ?? '') == "") errorCode.push("MissingStartDate")
  // if(!data?.mission_plan?.steps?.length) simuErrorCode.push("MissingSteps")
  // if(!((data?.mission_plan?.cur_step ?? -1) > -1)) simuErrorCode.push("MissingCurrentStep")
  // else if(data?.mission_plan.steps.findIndex(s => s.id == data?.mission_plan?.cur_step) == -1) simuErrorCode.push("MissingCurrentStep")
  // if(data?.mission_plan?.steps?.some(s => !((s?.prfNav_id ?? -1) > -1))) simuErrorCode.push("MissingProfilNavOnStep")
  // if(data?.mission_plan?.payload?.length && data?.mission_plan?.steps?.some(s => s?.payload_enable && !((s?.prfSci_id ?? -1) > -1))) simuErrorCode.push("MissingProfilSciOnStep")
  return errorCode
}
